<template>
  <div class="global-section">
    <div class="global-section-head" v-if="title">
      <h3 class="global-section-title">
        <span class="global-section-title-txt">{{ title }}</span>
        <slot name="sub-title"></slot>
      </h3>
      <span :class="suffixStyle"
            @click="handleSuffixTextAction"
            v-if="suffixText">{{ suffixText }}</span>
      <slot class="global-section-suffix-box" name="head-suffix"></slot>
    </div>
    <div class="global-section-desc" v-if="desc">{{desc}}</div>
    <slot name="desc"></slot>
    <div class="global-section-body" :style="bodyStyle">
      <slot name="body"></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'global-section',

    props: {
      title: String,
      desc: String,
      suffixText: String,
      suffixTextAction: {
        type: Function,
        default () {
          return null;
        },
      },
    },
    computed: {
      suffixStyle () {
        const classes = ['global-section-suffix'];

        if (this.suffixTextAction) {
          classes.push('global-section-link');
        }

        return classes;
      },
      bodyStyle () {
        if (!this.title) {
          return {
            paddingTop: '0px',
          };
        }
        return {};
      },
    },
    methods: {
      handleSuffixTextAction () {
        if (this.suffixTextAction && typeof this.suffixTextAction === 'function') {
          this.suffixTextAction();
        }
      },
    },
  };
</script>

<style lang="less" src="./index.less"></style>
